import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchRating(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/players/rating', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
